import { X, AlertTriangle, CheckCircle } from "lucide-react";

export default function ConfirmModal({ open, onClose, title, message, onConfirm, variant }) {
  if (!open) return null;

  const isSuccess = variant === "success";
  const Icon = isSuccess ? CheckCircle : AlertTriangle;
  const iconBg = isSuccess ? "#e0f7f4" : "#fef2f2";
  const iconBorder = isSuccess ? "#A4E5E0" : "#fca5a5";
  const iconColor = isSuccess ? "#0C6170" : "#d94f4f";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 400 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: iconBg, border: `1.5px solid ${iconBorder}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon size={17} color={iconColor} />
            </div>
            <div style={{ fontFamily: "'Google Sans Flex',sans-serif", fontWeight: 700, fontSize: 17, color: "#062830" }}>{title}</div>
          </div>
          <button className="btn btn-g btn-xs" onClick={onClose}><X size={14} /></button>
        </div>
        <div style={{ fontSize: 14, color: "#0C6170", lineHeight: 1.6, marginBottom: 20 }}>{message}</div>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button className="btn btn-g btn-sm" onClick={onClose}>Cancel</button>
          <button className={`btn btn-sm ${isSuccess ? "btn-p" : "btn-d"}`} onClick={() => { onConfirm?.(); onClose(); }}>Confirm</button>
        </div>
      </div>
    </div>
  );
}
